import { checkResponse, get, e } from '@/helpers/http.js'

export function getProjects () {
  return get(e('/api/v1/projects'))
    .then(checkResponse)
}
